import {
  Typography,
  TypographyColors,
  TypographyVariants
} from "@certa/catalyst/components/Typography";
import { Stack } from "@certa/catalyst/layouts/Stack";
import type { Badge } from "@certa/types";

export const BadgePopoverContent = ({ badge }: { badge: Badge }) => {
  return (
    <Stack
      padding="16"
      gap="8"
      maxWidth="20rem"
      maxHeight="10rem"
      overflow="auto"
    >
      <Typography
        variant={TypographyVariants.OVERLINE_SMALL}
        color={TypographyColors.NEUTRAL_700}
      >
        {badge.name}
      </Typography>
      {badge.helpText && (
        <Typography variant={TypographyVariants.LABEL_SM}>
          {badge.helpText}
        </Typography>
      )}
    </Stack>
  );
};
